export class ResindirContratoRequest{
    public fechaResicion: string | null = ""
    public idContrato: number = 0
}